import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'

const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'groups',
    model: 'group',
    loading: false,
    list: [],
    selected: {
      active: true,
      name: [],
      pitch: '',
      matches: [],
    },
    idSelected: '',
  }
}

const state = initialState()

const getters = {
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        name: item.name,
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
  async getOne({ commit, state, rootState }, { phaseId, groupId }) {
    let tournamentId = rootState.tournaments.idSelected
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`tournaments/${tournamentId}/phases/${phaseId}/groups/${groupId}`)
      .finally(() => commit('setLoading', false))
    const item = data.data ? data.data[state.model] : {}

    item.phaseId = phaseId
    return item
  },
  async fetchOne({ commit, dispatch }, { phaseId, groupId }) {
    let item = await dispatch('getOne', { phaseId, groupId })
    commit('setOne', item)
    return item
  },
  async fetchList({ commit, state, rootState }, phaseId) {
    let tournamentId = rootState.tournaments.idSelected
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`tournaments/${tournamentId}/phases/${phaseId}/groups`)
      .finally(() => commit('setLoading', false))

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async create({ dispatch, commit, state, rootState }, payload) {
    let tournamentId = rootState.tournaments.idSelected
    const phaseId = payload.phaseId
    delete payload.phaseId

    commit('setLoading', true)
    const { data } = await apiAxios
      .post(
        `tournaments/${tournamentId}/phases/${phaseId}/groups/create`,
        payload
      )
      .finally(() => commit('setLoading', false))
    notify(data.message)
    // dispatch('fetchList')
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async update({ dispatch, commit, state, rootState }, payload) {
    let tournamentId = rootState.tournaments.idSelected
    const groupId = payload._id
    const phaseId = payload.phaseId
    delete payload.phaseId

    commit('setLoading', true)
    const { data } = await apiAxios
      .put(
        `tournaments/${tournamentId}/phases/${phaseId}/groups/${groupId}`,
        payload
      )
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
    // dispatch('fetchList')
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async delete({ dispatch, commit, rootState }, { phaseId, groupId }) {
    let tournamentId = rootState.tournaments.idSelected
    commit('setLoading', true)
    const { data } = await apiAxios
      .delete(`tournaments/${tournamentId}/phases/${phaseId}/groups/${groupId}`)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
    // dispatch('fetchList')
  },
  async addOrDelMatch({ dispatch, commit, rootState }, params) {
    let tournamentId = rootState.tournaments.idSelected
    params.tournamentId = tournamentId
    commit('setLoading', true)
    const { data } = await apiAxios
      .post('/tournaments/phases/groups/addOrDelMatch', params)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
  },
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
